import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Fields,
    SingleSelect,
    HorizontalFlex,
    FieldLabel,
    ButtonWithIconSecondary,
    icons,
} from 'smartsuite-ui';
import { predicateValues } from '../constants/constants';
import { useLabelContext } from '../hooks/labelContext';
import { buildFilterWarning } from './filtersModalUtils';

/* eslint-disable complexity */
export default function FilterSingleSelect(props) {
    const { dashboardLabels, predicateLabels } = useLabelContext();
    const value = props.filter?.values ?? [];

    function handleFilterValueChange(values) {
        const updatedFilter = {
            [props.filterKey]: {
                predicate: {
                    textField: predicateLabels.isIn,
                    valueField: predicateValues.isIn,
                },
                ...props.filter,
                values: !values ? [] : [values],
            },
        };

        props.updateFilter(
            updatedFilter,
            props.availableFilter.cascadeChildKey
        );
    }

    function renderFilterLabel() {
        const label =
            props.showAsterisk && props.isRequired
                ? `${props.availableFilter.label}*`
                : props.availableFilter.label;

        if (!props.isAdditionalFilter) {
            return label;
        }

        return (
            <HorizontalFlex>
                <FieldLabel>{label}</FieldLabel>
                <ButtonWithIconSecondary
                    iconClass={icons.x}
                    onClick={props.removeAdditionalFilter(props.filterKey)}
                />
            </HorizontalFlex>
        );
    }

    return (
        <Fields
            cssClassModifiers={[
                'no-background',
                'no-pad-top-bottom',
                'no-wrap',
                props.isEditor ? 'column' : '',
            ]}
        >
            <SingleSelect
                disabled={props.disabled}
                isValid={!props.isRequired || !_.isEmpty(value)}
                label={renderFilterLabel()}
                menuPortalTarget={props.isEditor ? document.body : null}
                onChange={handleFilterValueChange}
                options={props.options}
                styles={{
                    menuPortal: (styles) => ({
                        ...styles,
                        zIndex: 10,
                    }),
                }}
                textField="textField"
                valueField="valueField"
                value={value}
            />
            {props.availableFilter.appliesToDataSubset && (
                <div className="filter-warning-icon">
                    <span
                        className={icons.warningFilled}
                        title={buildFilterWarning(
                            props.availableFilter.label,
                            dashboardLabels
                        )}
                    />
                </div>
            )}
        </Fields>
    );
}
/* eslint-enable complexity */

FilterSingleSelect.propTypes = {
    availableFilter: PropTypes.instanceOf(Object).isRequired,
    disabled: PropTypes.bool.isRequired,
    filter: PropTypes.instanceOf(Object),
    filterKey: PropTypes.string.isRequired,
    isAdditionalFilter: PropTypes.bool.isRequired,
    isEditor: PropTypes.bool,
    isRequired: PropTypes.bool.isRequired,
    options: PropTypes.instanceOf(Array).isRequired,
    removeAdditionalFilter: PropTypes.func.isRequired,
    showAsterisk: PropTypes.bool.isRequired,
    updateFilter: PropTypes.func.isRequired,
};

FilterSingleSelect.defaultProps = {
    filter: {},
    isEditor: false,
};
